import React from 'react';
import { Alert, Snackbar } from '@mui/material';

export interface NotistackState {
  open: boolean;
  message: string;
  autoHideDuration?: number;
  severity?: 'info' | 'success' | 'warning' | 'error';
  anchorOrigin?: {
    vertical: 'bottom' | 'top',
    horizontal: 'center' | 'left' | 'right'
  };
}
export const defaultNotistackState: NotistackState = {
  open: false,
  message: '',
  severity: 'success',
  autoHideDuration: 2000,
  anchorOrigin: { vertical: 'top', horizontal: 'center' }
};
interface NotistackProps extends NotistackState {
  onClose: () => void;
}
export default function Notistack(props: NotistackProps) {
  const {
    open, message, severity = 'success', autoHideDuration = 4000,
    anchorOrigin = { vertical: 'top', horizontal: 'center' },
    onClose
  } = props;

  return (
    <Snackbar
      style={{zIndex:9999}}
      open={open}
      autoHideDuration={autoHideDuration}
      anchorOrigin={anchorOrigin}
      onClose={onClose}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant='filled'
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}